import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

export const masterDataSkillTestSchema = validator.object().shape({
  skillTestName: validator.string().emptyToNull().label("試験名（技能）").required(),
  cfSkillTestRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("期間更新CSVのコード（列CF）")
    .required(),
});
